/* global I18n */

import React from "react"
import ToggleSwitch from "./toggle_switch"
import {use_configuration, EXAM_CONDITIONS_MIN_LENGTH}
  from "./configuration_provider"

function ExamConditions() {
  const {configuration, update_configuration} = use_configuration()
  const {exam_conditions, max_length} = configuration
  const min_no_of_questions = Math.min(max_length, EXAM_CONDITIONS_MIN_LENGTH)

  function handle_toggle() {
    update_configuration({
      exam_conditions: !exam_conditions,
      ...(!exam_conditions && {spelling_exercises: "included"}),
      ...(!exam_conditions && {muscle_facts: "included"})
    })
  }

  return (
    <div className="control-item control-item--toggle">
      <div className="info">
        <h4 className="title">
          {I18n.t("js.quiz_mode_selector.exam_conditions.title")}
        </h4>
        <p className="description">
          {I18n.t("js.quiz_mode_selector.exam_conditions.text")}
        </p>
      </div>
      <div className="control toggle">
        <ToggleSwitch
          checked={exam_conditions}
          onChange={handle_toggle}
        />
      </div>
      <p className="sub-text">
        {I18n.t("js.quiz_mode_selector.exam_conditions.sub_text.part_1")}
        <strong>{min_no_of_questions}</strong>
        {I18n.t("js.quiz_mode_selector.exam_conditions.sub_text.part_2")}
        <strong>
          {I18n.t("js.quiz_mode_selector.exam_conditions.sub_text.or_higher")}
        </strong>
      </p>
    </div>
  )
}

export default ExamConditions
